

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const promotionApi = {


  // Admin/User: Get single promotion
  getPromotion: async (promoId) => {
    const response = await axios.get(`${API_BASE_URL}/promotions/${promoId}`);
    return response.data;
  },

  // User: Apply promotion (you need to add this endpoint to backend)
  applyPromotion: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/promotions/apply`, data);
    return response.data;
  },

  // User: Validate promo code
  validatePromoCode: async (promoCode, serviceType, userId) => {
    const response = await axios.post(`${API_BASE_URL}/promotions/validate`, {
      promo_code: promoCode,
      service_type: serviceType,
      user_id: userId
    });
    return response.data;
  }
};

export default promotionApi;